/// <amd-module name="Build/Common/Library/Constants" />
/**
 * Build Definition ProcessType copied from vss-build-web\definitions\Constants.ts
 * Copied to avoid loading an additional 146kb of minified scripts from build-definitions.webproj
 */
export namespace ProcessType {
    export let Designer = 1;
    export let Yaml = 2;
    export let Docker = 3;
}

export namespace NavConstants {
    export const buildId = "buildId";
    export const changeId = "changeId";
    export const jobId = "jobId";
    export const planId = "planId";
    export const stepId = "stepId";
    export const timelineId = "timelineId";
    export const fullTimeline = "fullTimeline";
    export const update = "update";
    export const jobQueueData = "jobQueueData";
    export const continuationToken = "continuationToken";
    export const job = "j";
    export const line = "l";
    export const stage = "s";
    export const task = "t";
    export const view = "view";
    export const logs = "logs";
    export const artifacts = "artifacts";
    export const treeState = "treeState";
    export const imageUri = "imageUri";
    export const type = "type";
    export const alias = "alias";
    export const tag = "tag";
    export const consumedArtifacts = "consumedArtifacts";
    export const publishedArtifacts = "publishedArtifacts";
    export const stageName = "stageName";
    export const poolId = "poolId";
}

export namespace TelemetryConstants {
    export const Area = "Build";

    export const RunsOverviewShow = "PipelineRunsOverview.Show";
    export const RunsOverviewLogs = "PipelineRunsOverview.ViewLogs";
    export const StagePanelSearch = "PipelineRunsStagePanel.Search";
    export const StagePanelFilter = "PipelineRunsStagePanel.Filter";
    export const StagePanelShow = "PipelineRunsStagePanel.Show";
    export const StagePanelLogs = "PipelineRunsStagePanel.ViewLogs";
    export const StagePanelAction = "PipelineRunsStagePanel.Action";
}
export namespace BuildOptionGUIDs {
    export const WitLinkingOptionGUID = "5d58cc01-7c75-450c-be18-a388ddb129ec";
}

